
<div id="notfound">
  <div class="notfound">
    <div class="notfound-404">
      <h1>Oops!</h1>
    </div>
    <h2>404 - İçerik Bulunamadı</h2>
    <p>Aradığınız Sayfa Yada İçeriğin Adresi Değişmiş - Çalışmıyor Olabilir. Notumuzu Aldık en kısa sürede Problemi Çözeceğiz.</p>
    <a routerLink="/">Ana Sayfaya Dön</a>
  </div>
</div>